import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, ParamMap, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import * as _ from 'lodash';
import { SessionService } from 'src/app/services/session.service';

@Component({
  selector: 'app-payment-process',
  templateUrl: './payment-process.component.html',
  styleUrls: ['./payment-process.component.scss']
})
export class PaymentProcessComponent implements OnInit, OnDestroy {
  private paramsSubscription?: Subscription;
  private queryParamsSubscription?: Subscription;
  private type: string = '';
  
  constructor(
    private sessionService: SessionService,
    private router: Router,
    private route: ActivatedRoute) { }

  ngOnInit(): void {
    this.paramsSubscription = this.route.paramMap.subscribe({
      next: (params) => this.type = params.get('type') ?? ''
    });
    this.queryParamsSubscription = this.route.queryParamMap.subscribe({
      next: (params) => this.handleParams(params)
    });
  }

  ngOnDestroy(): void {
    this.paramsSubscription?.unsubscribe();
    this.queryParamsSubscription?.unsubscribe();
  }

  private handleParams(params: ParamMap): void {
    switch (this.type?.toLowerCase()) {
      case 'fullnab':
        this.handleFullNabParams(params);
        break;
      case 'arrangementnab':
        this.handleArrangementNabParams(params);
        break;
    }
  }

  private handleFullNabParams(params: ParamMap): void {
    const successCodes = ['00', '08', '11'];
    const rescode = params.get('rescode') ?? '';
    const restext = params.get('restext') ?? 'Unknown error';

    if (_.some(successCodes, (x) => x === rescode)) {
      this.router.navigate(['/payment/success/fullnab']);
    } else {
      this.sessionService.showErrorDialog(`Error processing payment: ${restext}.`);
      this.router.navigate(['/payment/payinfull']);
    }
  }

  private handleArrangementNabParams(params: ParamMap): void {
    const successCodes = ['00', '08', '11'];
    const rescode = params.get('strescode') ?? '';
    const restext = params.get('strestext') ?? 'Unknown error';

    if (_.some(successCodes, (x) => x === rescode)) {
      this.router.navigate(['/payment/success/arrangementnab']);
    } else {
      this.sessionService.showErrorDialog(`Error processing payment plan: ${restext}.`);
      this.router.navigate(['/payment/paybyarrangement']);
    }
  }
}
